import { Expose } from "class-transformer"
import ActivityHistoryLog from "./activity-history-log"
import SESSION_ACTION from "./session-action"
import _ from "lodash"

interface SessionChangeDetail {
  companyName: string | null
  companyId: number | null
  officeName: string | null
  officeStreet: string | null
  officeHouseNumber: string | null
  officeCity: string | null
  officeZip: string | null
  actionType: string
}

class SessionChangeLog extends ActivityHistoryLog {

  @Expose()
  public sessionActionEnum: SESSION_ACTION | null = null

  public get sessionChangeDetail(): SessionChangeDetail  {
    const { office = null } = this.activityHistory.employee
    const { company = null }  = office

    return {
      companyName: company ? company.name : null,
      companyId: company ? company.id : null,
      officeName: office ? office.officeName : null,
      officeStreet: office ? office.officeStreet : null,
      officeHouseNumber: office ? office.officeHouseNumber : null,
      officeCity: office ? office.officeCity : null,
      officeZip: office ? office.officeZip : null,
      actionType: this.sessionActionEnum as string
    }
  }

}

export default SessionChangeLog
